'use strict';

import React from 'react';

var CheckoutTerms = React.createClass({
  render: function() {
    return (
        <div className="terms-content" dangerouslySetInnerHTML={{__html: this.props.children}} />
    );
  }
});


export default CheckoutTerms;


/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/react/components/checkout-terms.jsx
 **/